requirejs.config({
    baseUrl: BASE_CONFIG.path,
    waitSeconds: 0,
    paths: {
        "jquery": "lib/jquery/dist/jquery.min",
        "cookie": "lib/jquery/dist/jquery.cookie",
        "css": "lib/require-css/css.min",
        "escroll": "lib/easy-scroll/easy-scroll",
        "ISwiper": "lib/ISwiper/dist/js/ISwiper.min",
        "Swiper": 'lib/Swiper/swiper.min',
        "tabTrace": 'lib/tab-trace/tabTrace',
        'imgZoom': "lib/img-zoom/amplifier",
        "http": 'lib/axios/axios.min',
        "Vue": 'lib/vue/dist/vue.min',
        'qs': 'lib/qs/qs',
        "text": "lib/require-text/text",
    },
    map: {
        "*": {
            "css": "lib/require-css/css.min"
        }
    },
    shim: {
        "cookie": {
            deps: ["jquery"]
        }
    }
})

requirejs(['page/render', 'page/deps'])